import React from 'react';
import { painPoints } from '../data/content';
export function ProblemSection() {
  return <section className="w-full bg-ink-900 px-4 py-10 sm:px-6 sm:py-14" data-id="element-129" data-mp="2lstkdivokeg4">
      <div className="mx-auto max-w-4xl text-center" data-id="element-130" data-mp="2lqgu8ifrqxrz">
        <h2 className="text-xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-131" data-mp="30hzit4mp20my">
          ¿Cuántos meses más vas a cargar esa mochila de cemento?
        </h2>

        <p className="mx-auto mt-3 max-w-2xl text-[13px] leading-relaxed text-neutral-400 sm:text-base" data-id="element-132" data-mp="39hcqbrr9cf51">
          Tenés el local. Tenés la mercadería. Tenés ganas de vender. Pero hay
          stock parado que no se mueve, redes que nadie mira y clientes que dicen
          "vuelvo" y no vuelven nunca.
        </p>

        <ul className="mt-6 grid gap-2.5 text-left sm:grid-cols-2" data-id="element-133" data-mp="3ei0jok2yl82f">
          {painPoints.map(point => <li key={point} className="flex items-start gap-2.5 rounded-xl border border-white/10 bg-ink-800 p-4" data-id="element-134" data-mp="1p2u4f3d7adni">
              <span aria-hidden="true" className="text-sm leading-none" data-id="element-135" data-mp="jddfih4jgszr">
                ❌
              </span>
              <span className="text-[13px] leading-relaxed text-neutral-300" data-id="element-136" data-mp="obol2fnswhc6">
                {point}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-2xl text-base font-extrabold leading-snug text-gold-400 sm:text-lg" data-id="element-137" data-mp="sbyrtujf3bs3">
          ¿Y si esta semana podés convertir ese stock clavado en efectivo con
          textos que ya vienen listos para copiar y pegar?
        </p>
      </div>
    </section>;
}